import styled from 'styled-components';

const FallbackRoot = styled.div`
  min-height: 120px;
  width: 100%;
`;

const RoutePageFallback = () => <FallbackRoot aria-hidden />;

export default RoutePageFallback;
